/* eslint-disable no-unused-vars */
import React, { createContext, useContext } from 'react';
import { useBreakpoint } from '../utils/useIsMobile';

const MobileContext = createContext({
  isMobile: true,
  isTablet: false,
  isDesktop: false,
  breakpoint: 'mobile',
});

export const useMobileContext = () => useContext(MobileContext);

export const MobileProvider = ({ children }) => {
  const { isMobile, isTablet, isDesktop, breakpoint } = useBreakpoint();

  // Temporarily force mobile mode for testing
  const forceMobile = false;

  return (
    <MobileContext.Provider
      value={{
        isMobile: forceMobile || isMobile,
        isTablet: !forceMobile && isTablet,
        isDesktop: !forceMobile && isDesktop,
        breakpoint: forceMobile ? 'mobile' : breakpoint,
      }}
    >
      {children}
    </MobileContext.Provider>
  );
};
